import React from "react";
import { DownloadOutlined } from "@ant-design/icons";
import { useAlert } from "../../context/AlertProvider";

const EmailAttachment = ({ attachment }) => {
  const { showAlert } = useAlert();

  const handleDownload = async () => {
    const fileUrl = attachment.fileUrl; // Change as needed
    const response = await fetch(fileUrl);
    const blob = await response.blob();

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = attachment.attachmentName; // Set filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    showAlert(
      "success",
      "Download Complete",
      `${attachment.attachmentName} downloaded successfully.`
    );
  };

  return (
    <div className="d-flex gap-10 align-items-center pr20">
      <span className="pr10">{attachment.attachmentName}</span>
      <DownloadOutlined onClick={handleDownload} />
    </div>
  );
};

export default EmailAttachment;
